import { render, staticRenderFns } from "./OutreachTasksPage.vue?vue&type=template&id=88aaf59c&scoped=true"
import script from "./OutreachTasksPage.vue?vue&type=script&lang=js"
export * from "./OutreachTasksPage.vue?vue&type=script&lang=js"
import style0 from "./OutreachTasksPage.vue?vue&type=style&index=0&id=88aaf59c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88aaf59c",
  null
  
)

export default component.exports